import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface ITopicsNavigationTargets {
    topUrlTargetState: string;
}

const keywordResearchNavigationTargets: ITopicsNavigationTargets = {
    topUrlTargetState: "organicsearch_website_landingpages_v2",
};

const searchAdvertisingNavigationTargets: ITopicsNavigationTargets = {
    topUrlTargetState: ROUTES.landingPages,
};

// SI reuses the Search Advertising Topics component but must keep navigation within the SI
// solution, so it targets the SI landing-pages mirror directly instead of the WI state.
const siSearchAdvertisingNavigationTargets: ITopicsNavigationTargets = {
    topUrlTargetState: SI_SEARCH_ROUTES.landingPages,
};

const topicsNavigationTargetsMap: Record<string, ITopicsNavigationTargets> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    search_website_topics: keywordResearchNavigationTargets,
    [ROUTES.topics]: searchAdvertisingNavigationTargets,
    // Sales Intelligence mirror of Search Advertising — stays within SI.
    [SI_SEARCH_ROUTES.topics]: siSearchAdvertisingNavigationTargets,
};

export const useTopicsNavigationTargets = (): ITopicsNavigationTargets => {
    const { state } = useCurrentStateAndParams();
    const navigationTargets = topicsNavigationTargetsMap[state.name];

    if (!navigationTargets) {
        throw new Error(
            `No topics navigation targets configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(topicsNavigationTargetsMap).join(", ")}`,
        );
    }

    return navigationTargets;
};
